import {useGetOrganization} from "../../services/ContentManager";
import {Polygon} from "@react-google-maps/api";
import React from "react";


export default function OrganizationAreaLayer({organizationId, overrideOrganization, color}){

    let {organization} = useGetOrganization(organizationId, !overrideOrganization);
    if(overrideOrganization)
        organization = overrideOrganization;

    const options = color ? {
        strokeColor: color,
        strokeOpacity: 0.9,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.2,
    } : undefined;

    return <>
        {
            organization.geojson && JSON.parse(organization.geojson).map((p,i) =>
                <Polygon path={p} key={i} options={options}/>)
        }
    </>
}
